import BaseCommand from "@/models/api/commands/BaseCommand";

export interface ChangeContractorCommandParams {
  Name: string | null;
  Surname: string | null;
  Country: string | null;
  City: string | null;
  PostalCode: string | null;
  StreetAndNumber: string | null;
  TIN: string | null;
  IsIndividual: boolean;
  ImportedContractorId?: null | string;
  NationalBusinessRegistryNumber: null | string;
}

export class ChangeContractorCommand extends BaseCommand {
  CommandName = "ChangeContractor";
  Command: ChangeContractorCommandParams;
  constructor(sessionId: string, operationId: string, params: ChangeContractorCommandParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
